import { useState } from 'react';
import TimeFrames from './TimeFrames';
import Chart from './Chart';
import { AreaChartProps } from './chartChartTypes';
import AreaChartKpi from './AreaChartKpi';
import Card from '../Card';
import clsx from 'clsx';

const AreaChart = <T extends string>({
    className,
    isLoading,
    data,
    timeframes,
    activePayload,
    defaultTimeframe,
    withKpi,
    withTimeFrames,
    label,
    activePayloadLabel,
    domain,
    tickFormatter,
    onActivePayloadChange,
    onTimeframeChange,
}: AreaChartProps<T>) => {
    const [timeframe, setTimeframe] = useState<T | undefined>(
        defaultTimeframe ?? (withTimeFrames ? timeframes[0] : undefined)
    );

    const handleTimeframeChange = (timeframe: T) => {
        setTimeframe(timeframe);
        onTimeframeChange && onTimeframeChange(timeframe);
    };

    const hasData = data.find(({ value }) => !!value);

    return (
        <div className={clsx('area-chart-container', className)}>
            <Card>
                {withKpi && (
                    <AreaChartKpi
                        data={data}
                        selectedTimeframe={timeframe as string}
                        activePayload={activePayload}
                        label={label}
                        activePayloadLabel={activePayloadLabel}
                        isLoading={isLoading}
                    />
                )}
                <div className='chart-container'>
                    <Chart
                        data={data}
                        onActivePayloadChange={onActivePayloadChange}
                        tickFormatter={tickFormatter}
                        selectedTimeframe={timeframe}
                        domain={domain ?? !hasData ? [-100, 100] : undefined}
                    />
                </div>
            </Card>
            {withTimeFrames && (
                <TimeFrames
                    timeframes={timeframes}
                    onTimeframeChange={handleTimeframeChange}
                    defaultTimeframe={defaultTimeframe}
                />
            )}
        </div>
    );
};

export default AreaChart;
